import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";
import {Observable, take} from 'rxjs';
import {itinerariesFeature, ItineraryState} from "../state/itineraries.state";
import {ItineraryModel} from "../models/itinerary.model";
import {ItinerariesActions, ItinerariesAPiActions, ItinerariesChannelActions} from "../state/itineraries.action";
import {accountsFeature} from "../../../account/angular/state/accounts.state";
import {TasksActions} from "../../../tasks/angular/state/tasks.actions";

@Injectable()
export class ItinerariesFacadeService implements EntitiesFacade<ItineraryModel> {

  constructor(@Inject(Store) private store: Store<ItineraryState>) {
  }

  subscribeToChannels(ids?: string[]): void {
    this.store.dispatch(ItinerariesChannelActions.subscribe({ids: ids}));
  }

  unsubscribeFromChannels(): void {
    this.store.dispatch(ItinerariesChannelActions.unsubscribe());
  }

  removeByIds(ids: string[]): void {
    this.store.dispatch(ItinerariesActions.removeByIds({ids: ids}));
  }

  removeAll(): void {
    this.store.dispatch(ItinerariesActions.removeAll());
  }

  setMany(entities: ItineraryModel[]): void {
    this.store.dispatch(ItinerariesActions.setMany({itineraries: entities}));
  }

  setOne(entity: ItineraryModel): void {
    this.store.dispatch(ItinerariesActions.setOne({itinerary: entity}));
  }

  updateOne(entity: ItineraryModel): void {
    throw new Error('Method not implemented.');
  }

  updateMany(entities: ItineraryModel[]): void {
    throw new Error('Method not implemented.');
  }

  selectOne(id: string): Observable<ItineraryModel> {
    return this.store.select(itinerariesFeature.selectItinerary(id));
  }

  selectAll(): Observable<ItineraryModel[]> {
    return this.store.select(itinerariesFeature.selectItineraries());
  }

  selectByIds(ids: string[]): Observable<ItineraryModel[]> {
    throw new Error('Method not implemented.');
  }

  selectIsLoading(): Observable<boolean> {
    throw new Error('Method not implemented.');
  }

  clearStore(): void {
    this.store.dispatch(ItinerariesActions.removeAll());
  }

  getOne(id: string, isSubscribeToChannel?: boolean): void {
  }

  getMany(ids?: string[], isSubscribeToChannel?: boolean): void {
    this.store.dispatch(ItinerariesAPiActions.getItineraries({ids: ids, isSubscribeToChannel: isSubscribeToChannel}));
  }


}
